/**
 * SA: Resource Hub
 * Handles tab/nav switching and card filtering for both PC and mobile layouts.
 *
 * Logic:
 * - "all" category: show every card
 * - Other categories: show cards whose data-categories includes the selected key
 * - PC nav and mobile tabs stay in sync (same category key drives both)
 */

class SaResourceHub extends HTMLElement {
  constructor() {
    super();
    this._activeCategory = 'all';
  }

  connectedCallback() {
    // PC nav buttons
    this._pcNavItems = this.querySelectorAll('.sa-resource-hub__nav-item');
    // Mobile tab buttons
    this._mobileTabs = this.querySelectorAll('.sa-resource-hub__tab');
    // PC cards
    this._pcCards = this.querySelectorAll('.sa-resource-hub__card');
    // Mobile list items
    this._mobileItems = this.querySelectorAll('.sa-resource-hub__list-item');

    this._pcNavItems.forEach((btn) => {
      btn.addEventListener('click', () => this._selectCategory(btn.dataset.category));
    });

    this._mobileTabs.forEach((btn) => {
      btn.addEventListener('click', () => this._selectCategory(btn.dataset.category));
    });

    this._pcCards.forEach((card) => {
      if (card.dataset.href) {
        card.addEventListener('click', () => {
          window.location.href = card.dataset.href;
        });
      }
    });
  }

  _selectCategory(category) {
    if (this._activeCategory === category) return;
    this._activeCategory = category;

    this._updateNav(category);
    this._filterCards(this._pcCards, category);
    this._filterCards(this._mobileItems, category);
  }

  _updateNav(category) {
    this._pcNavItems.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.category === category);
    });
    this._mobileTabs.forEach((btn) => {
      const isActive = btn.dataset.category === category;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  _filterCards(items, category) {
    items.forEach((item) => {
      if (category === 'all') {
        item.hidden = false;
        return;
      }
      const cats = (item.dataset.categories || '').split(',').map((c) => c.trim());
      item.hidden = !cats.includes(category);
    });
  }
}

customElements.define('sa-resource-hub', SaResourceHub);
